const currencies = [
    {
        code: 'eur', names: [
            { locale: 'en', label: 'euro' },
            { locale: 'fr', label: 'euro' },
            { locale: 'es', label: 'euro' },
        ]
    },
    {
        code: 'gbp', names: [
            { locale: 'en', label: 'pound sterling' },
            { locale: 'fr', label: 'livre sterling' },
            { locale: 'es', label: 'libra esterlina' },
        ]
    },
    {
        code: 'uyu', names: [
            { locale: 'en', label: 'uruguayan peso' },
            { locale: 'fr', label: 'peso uruguayen' },
            { locale: 'es', label: 'peso uruguayo' },
        ]
    },
    {
        code: 'clp', names: [
            { locale: 'en', label: 'chilean peso' },
            { locale: 'fr', label: 'peso chilien' },
            { locale: 'es', label: 'peso chileno' },
        ]
    },
    {
        code: 'ars', names: [
            { locale: 'en', label: 'argentine peso' },
            { locale: 'fr', label: 'peso argentin' },
            { locale: 'es', label: 'peso argentino' },
        ]
    },
    {
        code: 'mxn', names: [
            { locale: 'en', label: 'mexican peso' },
            { locale: 'fr', label: 'peso mexicain' },
            { locale: 'es', label: 'peso mexicano' },
        ]
    },
    {
        code: 'cop', names: [
            { locale: 'en', label: 'colombian peso' },
            { locale: 'fr', label: 'peso colombien' },
            { locale: 'es', label: 'peso colombiano' },
        ]
    },
    {
        code: 'usd', names: [
            { locale: 'en', label: 'american dollar' },
            { locale: 'fr', label: 'dollar Américain' },
            { locale: 'es', label: 'dólar americano' },
        ]
    },
    {
        code: 'cad', names: [
            { locale: 'en', label: 'canadian dollar' },
            { locale: 'fr', label: 'dollar canadien' },
            { locale: 'es', label: 'dólar canadiense' },
        ]
    },
    {
        code: 'pen', names: [
            { locale: 'en', label: 'peruvian soil' },
            { locale: 'fr', label: 'sol péruvien' },
            { locale: 'es', label: 'suelo peruanoe' },
        ]
    },
    {
        code: 'pyg', names: [
            { locale: 'en', label: 'Paraguayan guaraní' },
            { locale: 'fr', label: 'Guaraní' },
            { locale: 'es', label: 'Guaraní paraguayo' },
        ]
    },
    {
        code: 'srd', names: [
            { locale: 'en', label: 'Suriname Dollar' },
            { locale: 'fr', label: 'Dollar du Suriname' },
            { locale: 'es', label: 'Dólar surinamés' },
        ]
    },
    {
        code: 'usd', names: [
            { locale: 'en', label: 'United States Dollar' },
            { locale: 'fr', label: 'Dollar américain' },
            { locale: 'es', label: 'Dólar estadounidense' },
        ]
    },
    {
        code: 'gyd', names: [
            { locale: 'en', label: 'Guyanese dollar' },
            { locale: 'fr', label: 'Dollar de Guyane' },
            { locale: 'es', label: 'Dólar guyanés' },
        ]
    },
    {
        code: 'bob', names: [
            { locale: 'en', label: 'Boliviano' },
            { locale: 'fr', label: 'Boloviano' },
            { locale: 'es', label: 'Boliviano' },
        ]
    },
    {
        code: 'chf', names: [
            { locale: 'en', label: 'Swiss Franc' },
            { locale: 'fr', label: 'Franc suisse' },
            { locale: 'es', label: 'Franco suizo' },
        ]
    },
]

const formatNumber = number => {
    if (Math.round(number) === number) return number;
    return number.toFixed(2);
}



module.exports.formatPrice = product => {
    switch (product.currency.toLowerCase()) {
        case 'uyu':
            return `$U ${(product.amount / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        case 'ars':
        case 'cop':
        case 'gyd':
            return `$ ${(product.amount / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        case 'usd':
        case 'cad':
        case 'mxn':
        case 'srd':
            return `$ ${(product.amount / 100)}`;
        case 'clp':
            return `$ ${product.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        case 'gbp':
            return `£${formatNumber(product.amount / 100)}`;
        case 'pen':
            return `S/ ${(product.amount / 100)}`;
        case 'pyg':
            return `₲ ${product.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        case 'bob':
            return `Bs. ${(product.amount / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        case 'chf':
            return `CHF ${formatNumber(product.amount / 100)}`;
        default:
            return `${formatNumber((product.amount / 100)).toString().replace(/\./g, ',')}€`;
    }
}


module.exports.translateCurrency = (givenCurrency, locale) => {
    let currency = currencies.find(currency => currency.code === givenCurrency.toLowerCase());
    if (!currency) currency = currencies[0];

    let name = currency.names.find(name => name.locale === locale);
    if (!name) name = currency.names[0];

    return name.label;
}

